import { createFileRoute, useParams } from "@tanstack/react-router";
import { DeliveryOrderDetailPage } from "@/components/inventory/DeliveryOrderDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/delivery-orders_/$id")({
  component: AdminDODetail,
});

function AdminDODetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/delivery-orders_/$id" });
  return <DeliveryOrderDetailPage doId={id} />;
}
